import React, { ForwardRefRenderFunction, forwardRef } from "react";
//#region types
import { DocumentFormTypes } from "models/formTypes";
import { GenericDocumentTodoSelectionFormContainerProps } from "models/propTypes/documentPropTypes";
import { FormHandles } from "models/propTypes/genericFormProps";
import { TranslationKeys } from "translations";
import { UploadedFile } from "models/utilTypes/fileUtilsTypes";
import { WintSuperkollAPIModel as ApiModel } from "wint-api-client/dist/types";
//#endregion
//#region components
import { useGenericDocumentService } from "serviceHooks";
import GenericDocumentTodoSelectionForm from "./todoSelectionForm";
//#endregion
import * as Yup from "yup";

const GenericDocumentTodoSelectionFormContainer: ForwardRefRenderFunction<
  FormHandles,
  GenericDocumentTodoSelectionFormContainerProps
> = (props, ref) => {
  const genericDocumentService = useGenericDocumentService();
  const { genericDocument } = props;

  const initialValues = {
    comment: "",
    files: [],
  };

  const validationSchema = React.useMemo(
    () =>
      Yup.object<DocumentFormTypes.UploadGenericDocument>({
        comment: Yup.string().required(TranslationKeys.Validations.Required),
        files: Yup.array().of(
          Yup.object<UploadedFile>({
            contentType: Yup.string(),
            fileName: Yup.string(),
            fileSize: Yup.number(),
            data: Yup.string(),
          })
        ),
      }),
    []
  );

  const markAsDone = (values: DocumentFormTypes.UploadGenericDocument) => {
    const files = values.files.map((file): ApiModel.GenericDocumentImage => {
      return {
        contentType: file.contentType,
        name: file.fileName,
        imageData: file.data,
      };
    });
    return genericDocumentService.updateSentBackDocument(genericDocument.id, values.comment, files);
  };

  return (
    <GenericDocumentTodoSelectionForm
      ref={ref}
      {...props}
      validationSchema={validationSchema}
      defaultValues={initialValues}
      handleSubmit={markAsDone}
    />
  );
};

export default forwardRef(GenericDocumentTodoSelectionFormContainer);
